import PropTypes from 'prop-types';
import {
  compose,
  withState,
  setDisplayName,
  withHandlers,
  setPropTypes,
  defaultProps,
} from 'recompose';
import cc from 'classcat';

import { logger } from '../../lib/logger';
import { themes } from '../../lib/themes';
import ActionForm from '../ActionForm';
import Link from '../Link';
import withApplyPromoMutation from '../../hoc/queries/withApplyPromoMutation';

import styles from './styles.module.scss';

const AddPromo = ({
  theme,
  handleClick,
  linkClass,
  showForm,
  formClass,
  handleSubmit,
  code,
  className,
}) => (
  <div className={className}>
    <ActionForm
      onSubmit={handleSubmit}
      className={cc([formClass, { [styles.hideForm]: !showForm }])}
      theme={theme}
      placeholder="Promo code"
      defaultValue={code}
      autoFocus={true}
    />
    <Link
      theme={theme}
      onClick={handleClick}
      className={cc([linkClass, { [styles.hideLink]: showForm }])}
    >
      Add promo code
    </Link>
  </div>
);

const handlers = {
  handleClick:
    ({ setShowForm }) =>
    (event) => {
      event.preventDefault();
      setShowForm(true);
    },
  handleSubmit:
    ({ applyPromo, orderId, onError, setShowForm }) =>
    async (code) => {
      try {
        await applyPromo({ orderId, code });
        setShowForm(false);
      } catch (error) {
        onError(error?.graphQLErrors?.[0] || error);
        logger.info(error, { orderId, code });
      }
    },
};

export default compose(
  setDisplayName('AddPromoCode'),
  setPropTypes({
    orderId: PropTypes.string.isRequired,
    code: PropTypes.string,
    theme: PropTypes.oneOf(themes),
    className: PropTypes.string,
    linkClass: PropTypes.string,
    formClass: PropTypes.string,
    onError: PropTypes.func,
  }),
  defaultProps({
    code: '',
    onError: () => {},
  }),
  withState('showForm', 'setShowForm', false),
  withApplyPromoMutation(),
  withHandlers(handlers)
)(AddPromo);
